import { Chip, Stack, Typography } from '@dtx-company/design-system/src'
import { ChipIcon } from './subcomponents/ChipIcon'
import { FilledLinkToWebField } from '@prismicio/client'
import { IconComponent } from '@dtx-company/design-system/src/types/util'
import { chipClasses } from '@mui/material'
import { forwardRef } from 'react'
import { useLOCGPrismicContext } from '../hooks/useLOCGPrismicContext'
import useTranslation from 'next-translate/useTranslation'

export const GENERATOR_HEADING_ID = 'generator-heading'

export const GeneratorHeading = forwardRef<HTMLDivElement>((_, ref) => {
  const { locgV2Data } = useLOCGPrismicContext()
  const { t } = useTranslation('logged-out-generator')

  return (
    <Stack
      ref={ref}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        display: { xs: 'block', md: 'flex' },
        my: { md: 2 },
        px: { xs: 4, md: 12.5, xl: 4 },
        pt: { xs: 5, md: 6, lg: 0 },
        pb: { xs: 5, md: 'unset' },
        h1: {
          textAlign: {
            xs: 'center',
            md: 'unset'
          }
        },
        // NAV_V2_LOGGED_OUT_LINKS_BP = 993px
        '@media (max-width: 993px)': {
          boxShadow: 'inset 0px 2px 2px -1px rgba(0,0,0,.1)'
        }
      }}
    >
      <Typography
        component="h1"
        variant={{ xs: 'subtitleMedium', md: 'headlineMedium', lg: 'headlineLarge' }}
        data-testid="desktop-title"
      >
        {t('Header.title')}
      </Typography>

      <Stack
        alignItems="end"
        gap={2}
        sx={{
          display: {
            xs: 'none',
            lg: 'flex'
          },
          [`& .${chipClasses.root}`]: {
            maxWidth: 'unset',
            cursor: 'pointer',
            img: {
              ml: 2,
              mr: 1
            }
          }
        }}
        id={GENERATOR_HEADING_ID}
      >
        {locgV2Data.heading_chip.map(({ text, icon, link }) => (
          <Chip
            key={text}
            component="a"
            href={(link as FilledLinkToWebField).url}
            target="_blank"
            variant="outlined"
            startIcon={ChipIcon.bind(null, { icon }) as unknown as IconComponent}
            label={text}
            data-testid="heading-chip"
            data-heap-id="LoggedOutGenerator_Heading_MarketingChip"
            aria-label={t('LoggedOutGenerator.MarketingChip.ariaLabel', { text })}
          />
        ))}
      </Stack>
    </Stack>
  )
})

GeneratorHeading.displayName = 'GeneratorHeading'
